var render, staticRenderFns
import script from "./AppTransition.vue?vue&type=script&lang=js"
export * from "./AppTransition.vue?vue&type=script&lang=js"
import style0 from "./AppTransition.vue?vue&type=style&index=0&id=47a9131a&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports